// extracted by mini-css-extract-plugin
export default {"container":"dp-z","brandName":"ep-z","productName":"fp-z","productNamePdpEnhancements":"gp-z","breakLongProductName":"hp-z"};